module.exports = class Link {
    constructor() {
        this.href = '';
    }
};
